var map = {
	"./aparthotelclub/ic_tag_general.png": 92927,
	"./beachful/ic_tag_general.png": 15693,
	"./castlepedia/ic_tag_general.png": 24232,
	"./cocktayl/ic_tag_general.png": 42346,
	"./ic_tag_general.png": 23024,
	"./luxresortclub/ic_tag_general.png": 77474,
	"./parkful/ic_tag_general.png": 27437,
	"./prefabworld/ic_tag_general.png": 66597,
	"./rooftopclub/ic_tag_general.png": 30244,
	"./spaclub/ic_tag_general.png": 46858,
	"./worldcasino/ic_tag_general.png": 38483,
	"./zoopedia/ic_tag_general.png": 6622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65866;